import { ContentTypes } from 'src/app/shared/enums/content-types';
import { NewsletterFeature } from 'src/app/newsletter-management/enums/newsletter-feature';

// Non-content-type features live in their own enum so Features can reference them the same way it
// references ContentTypes/NewsletterFeature (a string enum cannot mix literal and referenced members).
export enum StandaloneFeature {
  SmartTagging = 'smartTagging',
  SmartLinking = 'relatedDataSmartLinking',
  // NOTE: temporary gate. Card and hovercard are agreed with the website (PM-106 handoff) but not
  // rendered by it yet, so with this off the "+" offers plain hyperlinks only. Only supported for
  // users who also have SmartLinking; that is a config convention, not enforced here.
  BodyLinkFormats = 'bodyLinkFormats',
}

export enum Features {
  PAGE = ContentTypes.PAGE,
  ARTICLE = ContentTypes.ARTICLE,
  GALLERY = ContentTypes.GALLERY,
  DIGITAL_PUBLICATION = ContentTypes.DIGITAL_PUBLICATION,
  NEWSLETTER = NewsletterFeature.Newsletter,
  SINGLE_SPONSOR = ContentTypes.SINGLE_SPONSOR,
  CONTENT_SET = ContentTypes.CONTENT_SET,
  SMART_TAGGING = StandaloneFeature.SmartTagging,
  SMART_LINKING = StandaloneFeature.SmartLinking,
  BODY_LINK_FORMATS = StandaloneFeature.BodyLinkFormats,
}
